export default __webpack_public_path__ + "static/media/i-finalizado_sura.cfe75742.svg";